/**
 * Codice interno derivato automaticamente.
 *
 * `code` è la maniglia operativa stabile di un'organizzazione: si usa negli
 * script e nelle query SQL, e non deve cambiare quando il cliente si rinomina.
 * Non c'è però ragione che l'admin lo inventi: si deriva dal prefisso se c'è,
 * altrimenti dal nome.
 */

/** `Frigerio Viaggi S.r.l.` -> `FRIGERIO_VIAGGI_SRL` */
export function slugifyCode(value: string): string {
  return (
    value
      .normalize('NFD')
      // Toglie i diacritici: 'Città' -> 'Citta'.
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 40)
      .replace(/_+$/, '')
  );
}

/**
 * Il prefisso vince sul nome: è già un identificativo, corto e stabile.
 * Restituisce '' se non c'è materiale da cui derivare.
 */
export function deriveCode(prefix: string | null | undefined, displayName: string): string {
  const fromPrefix = (prefix ?? '').trim();
  if (/^[A-Za-z]{4}$/.test(fromPrefix)) return fromPrefix.toUpperCase();
  return slugifyCode(displayName);
}
